import { useState } from 'react';
import { _setAxios, _success } from 'lib/Helper';

const useForm = (data, fetchTable, hideModal, whatsappPhoneIntegrationId) => {
    const [values, setValues] = useState({
        ...data
    });
    const [loading, setLoading] = useState(false);

    const handleChangeSetValue = (name, value) => {
        setValues(prevValues => ({ ...prevValues, [name]: value }));
    };

    const handleSubmit = (val) => {
        const params = {
            whatsapp_phone_integration_id: whatsappPhoneIntegrationId,
            whatsapp_modul_ids: val?.whatsapp_modul_ids,
        };

        let endpoint = "whatsapp/modul-integration";
        let method = "POST";

        if (data?.id) {
            endpoint = `${endpoint}/${data?.id}`;
            method = "PUT";
        }

        setLoading(true);

        _setAxios(endpoint, method, params)
            .then(resp => {
                if (resp.status) {
                    _success('topRight', 'Success', resp.data.message);
                    fetchTable(true);
                    hideModal();
                }
                setLoading(false);
            })
            .catch(() => setLoading(false));
    };

    return {
        values,
        loading,
        handleChangeSetValue,
        handleSubmit,
    };
};

export default useForm;
